import { useNavigate } from 'react-router-dom';

export const useNavigateWithScroll = () => {
  const navigate = useNavigate();

  const navigateWithScroll = (to: string, options?: { replace?: boolean; state?: any }) => {
    // Navigate'den önce scroll yap
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Navigate'i çağır
    if (options?.replace) {
      navigate(to, { replace: true, state: options.state });
    } else {
      navigate(to, { state: options?.state });
    }
  };

  return navigateWithScroll;
};
